import { render, staticRenderFns } from "./OrderDrawer.vue?vue&type=template&id=a60d5d18&scoped=true&"
import script from "./OrderDrawer.vue?vue&type=script&lang=js&"
export * from "./OrderDrawer.vue?vue&type=script&lang=js&"
import style0 from "./OrderDrawer.vue?vue&type=style&index=0&id=a60d5d18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60d5d18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VNavigationDrawer,VSpacer,VToolbar,VToolbarTitle})
